/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, oneOf as codecOneOf } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCommentBase } from './BaseCommentBase';
import { DeletedCommentReply } from './DeletedCommentReply';
import { ExtendedNonDeletedCommentReply } from './ExtendedNonDeletedCommentReply';
const BaseCommentBaseWithExtendedRepliesParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'replies',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecOneOf([
            ExtendedNonDeletedCommentReply,
            DeletedCommentReply,
        ])),
    ],
]), BaseCommentBase);
export class BaseCommentBaseWithExtendedReplies extends BaseCommentBase {
    static decode(input) {
        return BaseCommentBaseWithExtendedRepliesParser.decode(input).map(res => new BaseCommentBaseWithExtendedReplies(res));
    }
    static unsafeDecode(input) {
        return BaseCommentBaseWithExtendedReplies.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseCommentBaseWithExtendedRepliesParser.encode(data);
    }
    static schema() {
        return BaseCommentBaseWithExtendedRepliesParser.schema();
    }
}
